import { render, staticRenderFns } from "./DeleteResource.vue?vue&type=template&id=55a8960e&"
import script from "./DeleteResource.vue?vue&type=script&lang=js&"
export * from "./DeleteResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports